import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEmpresas,
  deleteEmpresa,
  getEmpresaById,
} from "../helpers/rutaEmpresas";
import ModalEmpresa from "./ModalEmpresa";
import "../css/tableclientes.css";

const TableEmpresas = () => {
  const [empresas, setEmpresas] = useState({
    data: {},
    loading: true,
  });

  const [empresa, setEmpresa] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEmpresas();
  }, []);

  const consultaEmpresas = () => {
    getEmpresas().then((datos) => {
      console.log("📦 Empresas:", datos);
      setEmpresas({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaEmpresas();
  };

  const handleShow = () => setShow(true);

  const modificaEmpresa = (id) => {
    getEmpresaById(id).then((resp) => {
      if (resp.ok) {
        setEmpresa(resp.empresa); // ✅ ahora sí solo el objeto empresa
        handleShow();
      } else {
        console.error("❌ Error al obtener empresa:", resp.error);
      }
    });
  };

  const eliminarEmpresa = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el empresa?");
    if (confirmar) {
      deleteEmpresa(id).then(() => {
        consultaEmpresas();
      });
    }
  };

  return (
    <div className="table-container">
      {!empresas.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Empresa</th>
                </tr>
              </thead>
              <tbody>
                {empresas.data.empresas.map((empresa) =>
                  empresa.activo ? (
                    <tr key={empresa._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaEmpresa(empresa._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarEmpresa(empresa._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{empresa.codemp}</td>
                      <td>{empresa.empresa}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalEmpresa
            show={show}
            handleClose={handleClose}
            empresa={empresa}
          />
        </>
      )}
    </div>
  );
};

export default TableEmpresas;
